export default __webpack_public_path__ + "images/bb2ef617dda25baa1d04ebd1e8b6f9ea.svg";